<template>
  <div class="page-footer">
    <div class="wrapper">
      <img class="logo" src="../../../assets/image/logo.png"/>
      <div class="content">
        <div style="padding-left: 0">
          <div class="title">社交媒体</div>
          <div class="media-img">
            <img src="../../../assets/image/xhs.png"/>
            <img src="../../../assets/image/dym.png"/>
            <img src="../../../assets/image/wx.png"/>
          </div>
          <div style="margin-top: 40px;font-size: 12px">全球售后服务热线</div>
          <div style="margin-top: 5px;font-size: 16px">400-633-8080</div>
        </div>
        <div>
          <div class="title">明星产品</div>
          <div class="category" @click="goPage('InstrumentIndex')">雅致盆底肌修复仪</div>
        </div>
        <div  style="padding-left: 80px">
          <div class="title">立即选购</div>
          <div class="category" @click="goLink('tm')">天猫官方旗舰店</div>
          <div class="category" @click="goLink('jd')">京东官方旗舰店</div>
          <div class="category" @click="goLink('dy')">抖音官方旗舰店</div>
          <div class="category" @click="goLink('hs')">小红书官方旗舰店</div>
        </div>
        <div  style="padding-left: 80px">
          <div class="title">服务中心</div>
          <div class="category" @click="goPage('ServiceCenter')">联系我们</div>
          <div class="category" @click="goPage('ServiceCenter')">在线客服</div>
        </div>
      </div>
      <div class="intro">
        <div class="icp" @click="goPage('icp')">
          湘ICP备2023005389号
        </div>
        <div>湘械广审(文)第250630-412017号</div>
        <div>请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data(){
    return {
      shopLink: [
        {code: 'tm',link: 'https://elechcy.tmall.com/shop/view_shop.htm?spm=pc_detail.27183998/evo365560b447259.shop_block.dentershop.e81d7dd6sUwGKw'},
        {code: 'jd',link: 'https://item.jd.com/10099773768137.html'},
        {code: 'dy',link: 'https://haohuo.jinritemai.com/views/shop/index?id=YrAzhJUm&url_maker=shop_sdk'},
        {code: 'hs',link: 'https://www.xiaohongshu.com/goods-detail/66052a9a5c3c5a000145c6a5?xhsshare=CopyLink&appuid=5c37034e000000000700a4c9&apptime=1716456882'},
      ]
    }
  },
  methods: {
    goPage(route){
      if(route === 'icp') {
        window.open('https://beian.miit.gov.cn/#/Integrated/index')
        return
      }
      sessionStorage.setItem('activeNav', route)
      this.$router.push('/'+route)
    },
    goLink(code){
      const shop = this.shopLink.filter((item) => item.code === code)
      if(shop.length> 0) {
        window.open(shop[0].link)
      }
    },
  }
}
</script>
<style lang="less" scoped>
.page-footer {
  background-color: #C4C4C4;
  height: 390px;
  color: #ffffff;
  .logo {
    width: 110px;
  }
  .wrapper {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 390px;
    background: #C4C4C4;
  }
  .content {
    display: flex;
    flex-direction: row;
    margin: 40px 0;
    >div {
      flex-basis: 25%;
       font-size: 15px;
       padding-left: 50px;
      .category {
        font-size: 13px;
        margin-top: 10px;
        cursor: pointer;
      }
      .category:hover {
        color: dodgerblue;
      }
    }
    .media-img {
      margin-top: 10px;
      img {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        -webkit-border-radius: 4px;
        margin-right: 5px;
        cursor: pointer;
      }
    }
  }
  .intro {
    font-size: 13px;
    .icp:hover {
      color: dodgerblue;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/new/components/Footer.vue